export const IM_MEMORY_PIN_CODE_STORAGE_KEY = 'WALLET_PIN_CODE' as const;
